<template>
  <b-card class="h-100">
    <div class="overflow-auto">
      <b-card-title class="mb-4">Nouveautés</b-card-title>
      <div
          v-for="(update, index) in updates"
          :key="index"
          v-b-modal.modal-1
          class="cursor-pointer mb-4"
          @click="goTo(update)">
      <h6 v-if="update.fields.date > date">La version {{ update.fields.version}} sera publiée le {{ update.fields.date | formatDate }}</h6>
      <h6 v-if="update.fields.date < date">La version {{ update.fields.version}} a été publiée {{ update.fields.date | formatDate }}</h6>
      <h6 v-if="update.fields.date == date">La version {{ update.fields.version}} est publiée aujourd'hui></h6>
      </div>
      <b-modal id="modal-1" :title="'Version '+ actualUpdate.fields.version" ok-only>
          <ul class="my-4">
            <li
              v-for="(changement,index) in actualUpdate.fields.changements"
              :key="index"> 
              {{ changement }}
            </li>
          </ul>
        <template #modal-footer>
          <b-button size="sm" variant="primary">
            RETOUR
          </b-button>
        </template>
      </b-modal>
    </div>
  </b-card>
</template>
<script>
import moment from "moment";

export default {
  name: "update",

  filters: {
    formatDate(date) {
      return moment(date).format('DD/MM/YYYY')
    },
  },

  data () {
    return {
      updates: [],
      date: '',
      actualUpdate: {
        fields: {},
      },
    }
  },

  mounted() {
    this.getNews();
    this.date = this.printDate();
  },

  methods: {
    printDate() {
      return new Date().toLocaleDateString();
    },

    getNews() {
      this.$contentful
        .getEntries()
        .then((res) => {
          this.updates = res.items;
      })
      .catch((e) => {
        console.error(e.stack)
      })
    },

    async goTo(update) {
      this.actualUpdate = update
    } ,
  },
}
</script>

<style scoped>
</style>